<template>
    <div class="flex border-t border-b -mt-px border-gray-200 draggable bg-white" :key="renderKey">
        <div class="w-6 self-start py-1.5 border-r border-gray-200">
        </div>
        <!-- Material. -->
        <div class="flex -ml-px flex-1 relative bg-white text-sm flex truncate">
            <div
                class="w-full flex-1 truncate resize-none overflow-hidden overflow-x-auto whitespace-pre-wrap shadow-none relative -my-px pt-1.5 pl-1.5 text-gray-600 border bg-white border-gray-200"
                v-text="item.material"
            ></div>
        </div>
        <!-- Quantity. -->
        <div class="w-32 flex -ml-px bg-white text-sm">
            <div
                class="w-full resize-none overflow-hidden overflow-x-auto whitespace-nowrap shadow-none relative -my-px pt-1.5 pl-1.5 text-gray-600 border bg-white border-gray-200"
                v-text="item.resolved+' / '+item.quantity"
            ></div>
        </div>
        <!-- Unit of Measure. -->
        <div class="w-16 flex -ml-px bg-white">
            <page-cell
                ref="uom"
                :read-only="true"
                :use-textarea-readonly="true"
                class="text-sm -my-px px-2 py-1.5 border border-gray-200"
                :placeholder="'Uom...'"
                v-model="item.uom"
                @blur="requestForMaterials.saveAndRefresh()"
                @input="$emit('changed')"
            ></page-cell>
        </div>
        <div class="w-72 -ml-px -my-px bg-white border border-gray-200 px-1 py-1"
        >
            <div class="flex truncate">
                <div v-if="item.itemReference"
                     class="truncate max-w-full inline-block text-xs ml-0.5 px-2 mt-0.5 py-0 rounded bg-gray-50 border border-gray-200 flex-shrink text-gray-500 hover:text-blue-600 cursor-pointer"
                     v-text="item.itemReference.item.reference + ' - ' +item.itemReference.item.name"
                >
                </div>
                <div v-else
                     class="truncate max-w-full inline-block text-xs ml-0.5 px-2 mt-0.5 py-0 rounded bg-red-50 border border-gray-200 flex-shrink text-red-500 hover:text-blue-600 cursor-pointer"
                     v-text="'Not Set'">
                </div>
            </div>
        </div>
        <!-- Status. -->
        <div
            class="flex w-16 -mt-px -mb-px ml-0 mr-0 flex justify-center border border-gray-200 bg-white">
            <ui-dropdown menu-class="p-3 w-[28em]"
                         v-if="requestForMaterials.status!=='Awaiting Acknowledgement'"
                         container-class="mx-1 flex flex-shrinke"
                         trigger-class="flex flex-1"
            >
                <template #default="{ toggle, open, close}">
                    <div @mouseover="item.resolvedStatus!=='Pending'?open():false" @mouseleave="close" class="">
                <span
                    class="fas fa-check text-green-400 bg-transparent text-xs mt-1 h-5 py-1 px-0 border border-white rounded-md"
                    v-if="item.resolvedStatus==='Resolved'"></span>
                        <span
                            class="far fa-clock text-green-400 bg-transparent text-xs mt-1 h-5 py-1 px-0 border border-white rounded-md"
                            v-if="item.resolvedStatus==='Partially Resolved'"></span>
                        <span
                            class="far fa-clock text-blue-500 bg-transparent text-xs mt-1 h-5 py-1 px-0 border border-white rounded-md"
                            v-if="item.resolvedStatus==='Pending'"></span>
                    </div>
                </template>
                <template #menu="{ close }">
                    <div class="w-full p-2 z-30 text-xs">
                        <div class="w-full font-medium text-gray-400 mb-1">
                            <div class="ml-2">Has been resolved by</div>
                            <div class="space-y-1 w-full">
                                <div
                                    v-for="purchaseOrder in getResolvedPos()"
                                    class="space-x-2 text-left w-full text-gray-500 pl-2 pr-1 py-0"
                                    :title="purchaseOrder.name"
                                >
                                    <div class="truncate w-full py-1"
                                         v-text="purchaseOrder.supplier+' '+purchaseOrder.reference"></div>
                                    <div
                                        v-for="item in purchaseOrder.items"
                                        class="flex w-full flex-1 space-x-2 text-left w-full pl-2 pr-1 py-0"
                                        :title="item.description"
                                    >
                                        <div class="truncate flex-1 flex flex-col text-blue-500">
                                            <span class="flex-1 flex flex-grow mx-1 relative truncate"
                                                  v-text="item.line+' - '+item.description+' ('+item.quantity+' '+item.unitOfMeasure+')'">
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </template>
            </ui-dropdown>
            <ui-dropdown menu-class="p-3 w-[22em]"
                         v-if="requestForMaterials.status!=='Awaiting Acknowledgement' && item.deliveryDates && item.deliveryDates.length"
                         container-class="mx-1 flex flex-shrink"
                         trigger-class="flex flex-1"
            >
                <template #default="{ toggle, open, close}">
                    <div @mouseover="open()" @mouseleave="close" class="">
                        <span
                            class="far fa-truck text-gray-400 bg-transparent text-xs mt-1 h-5 py-1 px-0 border border-white rounded-md"></span>
                    </div>
                </template>
                <template #menu="{ close }">
                    <div class="w-full p-0 z-30 text-xs">
                        <div class="w-full font-medium text-gray-400 mb-1">
                            <div
                                class="flex mt-0 border-t border-b border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold">
                                <div class="border-l border-gray-200 px-2 py-1 -mx-px flex-grow text-xs ">Date</div>
                                <div class="border-l border-gray-200 border-r px-2 py-1 -ml-px w-20 text-xs">Quantity
                                </div>
                            </div>
                            <template v-for="(line,key) in item.deliveryDates">
                                <div class="flex border-b border-gray-200">
                                    <div class="border-l border-gray-200 px-2 py-1 -mx-px flex-grow text-xs "><span
                                        class="font-semibold text-gray-600" v-text="line.date"></span>
                                    </div>
                                    <div class="border-l border-r border-gray-200 px-2 py-1 -ml-px w-20 text-xs"
                                         v-text="line.quantity">
                                    </div>
                                </div>
                                <div class="flex border-b" v-if="line.notes">
                                    <div class="border-l border-r border-gray-200 px-2 py-1 -mx-px flex-grow text-xs">
                                        Note: {{ line.notes }}
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </template>
            </ui-dropdown>
        </div>
        <!-- Dropdown. -->
        <div class="w-8 flex-shrink-0 self-start py-1.5">
            <ui-dropdown menu-class="p-3 w-80"
                         v-if="!readonly && requestForMaterials.status!=='Awaiting Acknowledgement'">
                <template #default="{ toggle }">
                    <button @click="toggle"
                            class="ml-2 w-5 h-5 flex items-center justify-center text-gray-300 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:z-10 relative rounded">
                        <i class="fa fa-ellipsis-h fa-fw"></i>
                    </button>
                </template>
                <template #menu="{ close }">
                    <ui-dropdown-item icon="fas fa-check" @click="close(); resolveAgainstPos()">
                        Resolve against existing PO item(s)
                    </ui-dropdown-item>
                    <ui-dropdown-divider v-if="item.resolvedStatus!=='Resolved'"></ui-dropdown-divider>
                    <ui-dropdown-item v-if="item.resolvedStatus!=='Resolved'" icon="fas fa-pound-sign"
                                      @click="close(); createPo();">
                        Create a PO to resolve this item
                    </ui-dropdown-item>
                    <ui-dropdown-divider></ui-dropdown-divider>
                    <ui-dropdown-item icon="far fa-truck" @click="adjustDeliveryData">
                        Add Delivery data
                    </ui-dropdown-item>
                </template>
            </ui-dropdown>
        </div>

    </div>
</template>

<script>

import UiDropdownDivider from "../../ui/UiDropdownDivider.vue";
import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import UiDropdown from "../../ui/UiDropdown.vue";
import UiButtonNew from "../../ui/UiButtonNew.vue";
import UiSelect from "../../ui/UiSelect.vue";
import AutoresizableTextarea from "../../ui/AutoresizableTextarea";
import PageCell from "../../ui/PageCell.vue";
import {cloneDeep} from "lodash";

export default {
    components: {
        PageCell,
        AutoresizableTextarea,
        UiSelect, UiButtonNew, UiDropdown, UiDropdownItem, UiDropdownDivider
    },
    props: {
        requestForMaterials: Object,
        item: Object,
        readonly: false,
        resourcePlanningReport: Object,
        purchaseOrders: Array,
    },
    data() {
        return {
            renderKey: 0,
        }
    },
    computed: {},
    methods: {
        createPo() {
            this.$modals.open('ProcurementResolveRFMToNewPO', {
                rfm: this.requestForMaterials,
                RFMItem: this.item,
                handle: async (modal, po) => {
                    modal.close();
                    window.location = route('mobile.procurement.packages.purchase-orders', {packageReference: po.defaultPackageReference}) + '?goto=id|' + po.id + '&mode=edit'
                },
            })
        },
        adjustDeliveryData() {
            this.$modals.open('ProcurementRFMItemDeliveryData', {
                rfm: this.requestForMaterials,
                rfmItem: this.item,
                handle: async (modal) => {
                    modal.close()
                },
            })
        },
        resolveAgainstPos() {
            this.$modals.open('ProcurementResolveRFMToPOs', {
                rfm: this.requestForMaterials,
                RFMItem: this.item,
                purchaseOrders: this.purchaseOrders,
                handle: async (modal) => {
                    modal.close()
                    this.$emit('update:requestForMaterials', this.requestForMaterials);
                },
            })
        },
        getResolvedPos() {
            let tree = [];
            let addToTree = (purchaseOrder, i, index) => {
                let s = tree.find((i) => i.id === purchaseOrder.id);
                if (!s) {
                    s = {
                        id: purchaseOrder.id,
                        supplier: purchaseOrder.supplier ? purchaseOrder.supplier : "<no supplier>",
                        supplierReference: purchaseOrder.supplierReference,
                        reference: purchaseOrder.fullReference,
                        items: [],
                    }
                    tree.push(s);
                }
                let item = cloneDeep(i);
                item.poString = purchaseOrder.supplier + ' ' + purchaseOrder.fullReference;
                item.line = index;
                s.items.push(item);
            }
            this.item.resolves.forEach((resolve) => {
                let po = this.purchaseOrders.find((i) => i.id === resolve.purchaseOrderId);
                if (po) {
                    let item = po.items.find((i) => i.id === resolve.purchaseOrderItemId);
                    if (item) {
                        addToTree(po, item, po.items.indexOf(item) + 1);
                    }
                }
            })
            return tree;
        }
    },
    async mounted() {

    }
}
</script>
